type ShadowListener = (enabled: boolean) => void
import { isProduction } from '@/types/api'

const STORAGE_KEY = 'shadow-enabled'
let listeners: ShadowListener[] = []
let lastEnabled: boolean | undefined
let storagePatched = false

function readEnabledFromStorage(): boolean {
  if (isProduction()) return false
  const v = localStorage.getItem(STORAGE_KEY)
  // 默认开启；存储 '0' 表示关闭，'1' 表示开启
  if (v === '0') return false
  if (v === '1') return true
  return true
}

function writeEnabledToStorage(enabled: boolean) {
  localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0')
}

function notifyIfChanged() {
  const now = readEnabledFromStorage()
  if (lastEnabled === now) return
  lastEnabled = now
  for (const l of listeners) l(now)
}

function ensureStoragePatched() {
  if (storagePatched) return
  storagePatched = true
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) {
      notifyIfChanged()
    }
  })
}

export function isShadowWorked(): boolean {
  if (isProduction()) return false
  return readEnabledFromStorage()
}

export function setShadowWorked(): () => void {
  ensureStoragePatched()
  if (isProduction()) {
    writeEnabledToStorage(false)
    notifyIfChanged()
    return () => {}
  }
  const prev = localStorage.getItem(STORAGE_KEY)
  writeEnabledToStorage(true)
  notifyIfChanged()
  return () => {
    if (prev === null) {
      localStorage.removeItem(STORAGE_KEY)
    } else {
      localStorage.setItem(STORAGE_KEY, prev)
    }
    notifyIfChanged()
  }
}

export function unSetShadowWorked() {
  ensureStoragePatched()
  writeEnabledToStorage(false)
  notifyIfChanged()
}

export function onShadowChange(listener: ShadowListener): () => void {
  ensureStoragePatched()
  listeners.push(listener)
  const current = isShadowWorked()
  if (lastEnabled === undefined) lastEnabled = current
  queueMicrotask(() => listener(current))
  return () => {
    listeners = listeners.filter((l) => l !== listener)
  }
}

